import FocusManagement from './util/FocusManagement';

const MAX_MOBILE_HAMBURGER_PX = 1199;

const expanderConfig = {
  hamburger: {
    toggleSelector: '.headerNav__hamburger',
    parentSelector: 'body',
    openClass: 'body--hamburgerOpen',
    transitionSelector: '.headerNav__menuWrap',
    onToggle: expanded => updateHamburgerMenuTabIndex(expanded)
  },
  search: {
    toggleSelector: '.header__searchToggle',
    parentSelector: '.siteHeader',
    openClass: 'siteHeader--searchOpen',
    transitionSelector: '.header__searchWrap',
    onToggle: expanded => searchToggle(expanded)
  }
};

function init() {
  configureExpander(expanderConfig.hamburger);
  configureExpander(expanderConfig.search);
  
  updateHamburgerMenuTabIndex(false);
  
  window.addEventListener('resize', () => manageMobileHamburger());
}

const fnExpandHamburger = () => toggleExpander(expanderConfig.hamburger, true);
const fnCollapseHamburger = () => toggleExpander(expanderConfig.hamburger, false);

/**
 * Toggle the tabIndex from 0 to -1 when the hamburger expands/collapses
 * Toggle the aria visibility of the hamburger toggle contents
 * Add focus trap and esc-behaviour when expanded
 */
function updateHamburgerMenuTabIndex(expanded) {
  document.querySelector('.headerNav__hamburger--open').toggleAttribute('aria-hidden', !expanded);
  document.querySelector('.headerNav__hamburger--closed').toggleAttribute('aria-hidden', expanded);
  document.querySelectorAll('.headerNav__menu a').forEach(el => el.tabIndex = (expanded) ? 0 : -1);
  
  const hamburger = document.querySelector('.headerNav__hamburgerWrap');

  if (expanded) {
    toggleExpander(expanderConfig.search, false);
    FocusManagement.enableFocusTrap(hamburger);
    FocusManagement.onEsc(fnCollapseHamburger);
  }
  else {
    FocusManagement.disableFocusTrap(hamburger);
    FocusManagement.offEsc(fnCollapseHamburger);
  }

  manageMobileHamburger(expanded);
}

function manageMobileHamburger(isHamburgerOpen = null) {
  const bodyClassList = document.body.classList;
  const isExpanded = (isHamburgerOpen !== null) ? isHamburgerOpen : bodyClassList.contains('body--hamburgerOpen');
  const isMobile = window.matchMedia(`(max-width: ${ MAX_MOBILE_HAMBURGER_PX }px)`).matches;
  const hasMobileHamburger = isExpanded && isMobile;

  bodyClassList.toggle('body--noScroll', hasMobileHamburger);
    
  if (hasMobileHamburger) {
    window.scrollTo(0, 0);
  }
}

function searchToggle(expanded) {
  if (expanded) {
    document.querySelector('.header__search .search__input').focus();
    
    const headerMenuToggler = document.querySelector('.headerNav__hamburger');
    toggleExpander(expanderConfig.hamburger, false);
  }

  document.querySelectorAll('.header__search input, .header__search button').forEach(el => el.tabIndex = (expanded) ? 0 : -1);
}

/**
 * Produces an "expander" for the header.  It toggles a class and aria-expanded when a button is clicked.
 * 
 * Options:
 *
 * toggleSelector: Selector for the button that toggles the expander
 * parentSelector: When the toggle button is clicked, the closest parent matching this selector is modified
 * openClass: The class added to the parentSelector when the expander is open
 * transitionSelector: If present, a "transitioning" class will be added to this element, and removed when this element completes a CSS transition
 * onToggle: (optional) function(isExpanded).  Called when the toggle changes
 */
function configureExpander(options) {
  const toggle = document.querySelector(options.toggleSelector);
  toggle && toggle.addEventListener('click', () => toggleExpander(options));
}

function toggleExpander(options, expand = null) {
  const toggle = document.querySelector(options.toggleSelector);
  const parent = toggle.closest(options.parentSelector);
  const isExpanded = (toggle.getAttribute('aria-expanded') === 'true');
  
  if (isExpanded === expand) { return; }
  
  const isExpanding = !isExpanded;
  toggle.setAttribute('aria-expanded', isExpanding ? 'true' : 'false');
  
  if (parent) {
    const transitionEl = options.transitionSelector && parent.querySelector(options.transitionSelector);
    
    if (transitionEl) {
      void(transitionEl.offsetHeight);
      transitionEl.classList.add('transitioning');
      
      if (transitionEl.expander__hasTransitionedHandler) { return; }
      
      transitionEl.expander_hasTransitionedHandler = true;
      transitionEl.addEventListener('transitionend', e => transitionEl.classList.remove('transitioning'));
    }
    
    // Expanding?  We add the class after tick to allow the transition class to take effect.
    if (isExpanding) {
      window.setTimeout(() => parent.classList.add(options.openClass), 1);
    }
    else {
      parent.classList.remove(options.openClass);
    }
  }
  
  options.onToggle && options.onToggle(isExpanding);
}

export default { init };